import jsCookie from 'js-cookie';

import { ECookieNames } from 'enums/cookieNames';

export function logoutClientRequest() {
  jsCookie.remove(ECookieNames.AccessToken);
}
